import { formatDate } from "@/modules/carga-trabalho";
import {
  AUSENCIA_PROGRAMADA,
  JUSTIFICATIVA_CONFLITOS_AVISO_AUSENCIA,
  justificativaConflitosAvisoAlocacao,
} from "@/modules/recursos/simulacao";
import type { ConflitoNovo, ConflitoNovoItem } from "@/modules/recursos/simulacao";
import type { ConflitoLinha } from "./types-justificativa-conflitos-dialog";

const periodo = (item: ConflitoNovoItem) => `${formatDate(item.inicio)} a ${formatDate(item.fim)}`;

/** "31/07 a 25/09/2026": o ano só no fim, como nos cartões de obra do Figma (12041:410015). */
const periodoCurto = (item: ConflitoNovoItem) =>
  `${formatDate(item.inicio).slice(0, 5)} a ${formatDate(item.fim)}`;

/** "Obra 33 - P. Meros" vira "33 - P. Meros", como no cartão do Figma. */
const semPrefixoObra = (rotulo: string) => rotulo.replace(/^Obra /, "");

export const ehAusencia = (conflito: ConflitoNovo) =>
  conflito.itens.some((item) => item.rotulo === AUSENCIA_PROGRAMADA);

/** A alocação que a alteração criou: pelo id e, sem ele, pela obra (a outra é a atual). */
function ordenar(
  conflito: ConflitoNovo,
  obraNova: string | undefined,
  alocacoesNovas: string[],
): [atual: ConflitoNovoItem, nova: ConflitoNovoItem] {
  const [primeiro, segundo] = conflito.itens;
  const porId = conflito.itens.findIndex(
    (item) => item.alocacaoId !== undefined && alocacoesNovas.includes(item.alocacaoId),
  );
  const indiceNova =
    porId !== -1 ? porId : conflito.itens.findIndex((item) => item.rotulo === obraNova);
  return indiceNova === 0 ? [segundo, primeiro] : [primeiro, segundo];
}

export function linhaDoConflito(
  conflito: ConflitoNovo,
  indice: number,
  obraNova: string | undefined,
  alocacoesNovas: string[] = [],
): ConflitoLinha | null {
  const chave = `${conflito.recurso}-${indice}`;
  if (ehAusencia(conflito)) {
    const ausencia = conflito.itens.find((item) => item.rotulo === AUSENCIA_PROGRAMADA);
    const obra = conflito.itens.find((item) => item.rotulo !== AUSENCIA_PROGRAMADA);
    if (!ausencia || !obra) return null;
    return {
      tipo: "ausencia",
      chave,
      recurso: conflito.recurso,
      obra: periodoCurto(obra),
      ausencia: periodo(ausencia),
      aviso: JUSTIFICATIVA_CONFLITOS_AVISO_AUSENCIA,
    };
  }
  const [atual, nova] = ordenar(conflito, obraNova, alocacoesNovas);
  return {
    tipo: "alocacao",
    chave,
    recurso: conflito.recurso,
    atual: { valor: semPrefixoObra(atual.rotulo), periodo: periodo(atual) },
    nova: { valor: semPrefixoObra(nova.rotulo), periodo: periodoCurto(nova) },
    aviso: justificativaConflitosAvisoAlocacao(atual.obraCodigo ?? ""),
  };
}
